import { gql } from '@apollo/client';

export * from './legacyRepos.query.generated';

export const LEGACY_REPOS = gql`
  query legacyRepos($order: QueryOrderEnum, $queryFilter: String, $page: Int, $perPage: Int) {
    legacyRepos(order: $order, queryFilter: $queryFilter, statusFilter: awaiting, page: $page, perPage: $perPage) {
      hasNextPage
      nodes {
        migrationStatus
        platform
        title
        url
        id
        softwareEscrow {
          id
          depositor {
            companyName
          }
          beneficiary {
            companyName
          }
        }
      }
      hasPreviousPage
      nodesCount
      pagesCount
    }
  }
`;
